import React, { ReactNode } from 'react'
import styles from './ButtonRounded.module.sass'

interface Props {
  className?: string
  ariaLabel?: string
  icon?: ReactNode
  mobileHeaderIcon?: ReactNode
  size?: 'xs' | 'sm' | 'md' | 'lg'
  mobileSize?: 'xs' | 'sm' | 'md' | 'lg'
  mobileHeaderSize?: 'xs' | 'sm' | 'md' | 'lg'
  theme?: 'neutral20' | 'light'
  backgroundTheme?: 'light' | 'dark'
  disabled?: boolean
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement | HTMLDivElement>
  ) => void
  onFocus?: (event: React.FocusEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  tabIndex?: number
}

const ButtonRounded = (props: Props) => {
  const {
    className = '',
    ariaLabel = undefined,
    icon = null,
    mobileHeaderIcon = null,
    size = 'lg',
    mobileSize = undefined,
    mobileHeaderSize = undefined,
    disabled = false,
    onClick = undefined,
    onFocus = undefined,
    tabIndex = undefined,
    theme = 'light',
    backgroundTheme = 'light',
  } = props

  const classeNames = `
    ${styles.root} 
    ${styles[`root--${size}`]}
    ${mobileSize ? styles[`root--mobile-${mobileSize}`] : ''} 
    ${mobileHeaderSize ? styles[`root--mobileHeader-${mobileHeaderSize}`] : ''} 
    ${styles[`root--${theme}`]}
    ${styles[`root--bg-${backgroundTheme}`]}
    ${className}`

  return (
    <button
      className={classeNames}
      type="button"
      onClick={onClick}
      onFocus={onFocus}
      tabIndex={tabIndex || (onClick ? undefined : -1)}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {!!icon && (
        <span className={`${styles.icon} ${mobileHeaderIcon ? styles['icon--desktopHeader'] : ''}`}>
          {icon}
        </span>
      )}
      {!!mobileHeaderIcon && (
        <span className={`${styles.icon} ${styles['icon--mobileHeader']}`}>{mobileHeaderIcon}</span>
      )}
    </button>
  )
}

export default ButtonRounded
